import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'completed-payment-method-pix',
    templateUrl: './completed.payment-method.pix.component.html',
    styleUrls: ['./../../completed.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompletedPaymentMethodPixComponent {
    @Input('paymentCode') paymentCode;
    @Input('paymentCodeQr') paymentCodeQr;

    constructor(
        protected toastr: ToastrService,
        protected translate: TranslateService
    ) {}

    public copied() {
        this.translate
        .get('COMPLETED.PIX_PAYMENT_CODE_COPIED')
        .subscribe(message => {
            this.toastr.info(message);
        });
    }
    public changeQrCodeSource(tag) {
        tag.setAttribute(
            'src',
            `https://api.qrserver.com/v1/create-qr-code/?data=${this.paymentCode}&size=250x250`
        );
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/completed/payment-method/pix/completed.payment-method.pix.component.ts